'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _songs = require('redux/modules/songs');

var songsActions = _interopRequireWildcard(_songs);

var _playlists = require('redux/modules/playlists');

var playlistsActions = _interopRequireWildcard(_playlists);

var _songs2 = require('selectors/songs');

var _SongsListRow = require('components/SongsList/SongsListRow');

var _SongsListRow2 = _interopRequireDefault(_SongsListRow);

var _Loader = require('components/Loader/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

var _SongsListSearchBar = require('components/SongsList/SongsListSearchBar');

var _SongsListSearchBar2 = _interopRequireDefault(_SongsListSearchBar);

var _SelectableList2 = require('components/SelectableList/SelectableList');

var _SelectableList3 = _interopRequireDefault(_SelectableList2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./SongsList.scss');

var SongsList = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    checkedSongs: state.songs.checkedSongs,
    playlistsLoaded: state.playlists.playlistsLoaded,
    playlistsLoading: state.playlists.playlistsLoading,
    songsLoaded: state.songs.songsLoaded,
    songsLoading: state.songs.songsLoading,
    songs: (0, _songs2.getFilteredSongs)(state)
  };
}, (0, _extends3.default)({}, songsActions, playlistsActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_SelectableList) {
  (0, _inherits3.default)(SongsList, _SelectableList);

  function SongsList() {
    var _ref;

    (0, _classCallCheck3.default)(this, SongsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = SongsList.__proto__ || (0, _getPrototypeOf2.default)(SongsList)).call.apply(_ref, [this].concat(args)));

    _this.selectableConfig = (0, _extends3.default)({}, _this.selectableConfig, {
      propsField: 'songs',
      updateFn: _this.props.updateCheckedSongs,
      checkedItemsPropsField: 'checkedSongs'
    });
    return _this;
  }

  (0, _createClass3.default)(SongsList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          playlistsLoaded = _props.playlistsLoaded,
          loadPlaylists = _props.loadPlaylists;

      if (!playlistsLoaded) {
        loadPlaylists();
      }
    }
  }, {
    key: 'onRowClick',
    value: function onRowClick(song) {
      this.toggleItemChecked(song.id);
    }
  }, {
    key: 'onSelectionChange',
    value: function onSelectionChange(checkedSongs) {
      this.props.onSelect(checkedSongs);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          t = _props2.t,
          songs = _props2.songs,
          playlistsLoading = _props2.playlistsLoading,
          className = _props2.className,
          searchable = _props2.searchable,
          checkedSongs = _props2.checkedSongs,
          autoFocus = _props2.autoFocus;

      var isEmptyResult = !playlistsLoading && !songs.length;

      return _react2.default.createElement(
        'div',
        null,
        searchable && _react2.default.createElement(_SongsListSearchBar2.default, {
          className: styles.searchBar,
          autoFocus: autoFocus
        }),
        _react2.default.createElement(
          'div',
          { className: (0, _bind2.default)(className, styles.list) },
          songs.map(function (song, index) {
            return _react2.default.createElement(_SongsListRow2.default, {
              key: song.id + '_' + song.track_number + '_' + song.wFileName,
              song: song,
              index: index,
              checked: checkedSongs[song.id],
              onClick: _this2.onRowClick
            });
          }),
          isEmptyResult && _react2.default.createElement(
            'div',
            { className: styles.emptyResults },
            t('Empty results')
          ),
          playlistsLoading && _react2.default.createElement(_Loader2.default, { alignCenter: true })
        )
      );
    }
  }]);
  return SongsList;
}(_SelectableList3.default), _class3.propTypes = {
  autoFocus: _propTypes2.default.bool,
  checkedSongs: _propTypes2.default.object,
  className: _propTypes2.default.string,
  loadPlaylists: _propTypes2.default.func,
  onSelect: _propTypes2.default.func,
  playlistsLoaded: _propTypes2.default.bool,
  playlistsLoading: _propTypes2.default.bool,
  searchable: _propTypes2.default.bool,
  songs: _propTypes2.default.array,
  t: _propTypes2.default.func,
  updateCheckedSongs: _propTypes2.default.func
}, _class3.defaultProps = {
  checkedSongs: {},
  onSelect: _noop3.default,
  songs: []
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onRowClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onRowClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onSelectionChange', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSelectionChange'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = SongsList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SongsList/SongsList.js
// module id = 2098
// module chunks = 1